var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./select-store-options.j2"] = require( "./select-store-options.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/personal-stylist/select-store-us.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<select id=\"personal_shopper_stores\" name=\"personal_shopper_stores\" class=\"c-form__select js-select-shopper-store\" data-qa-select-store>\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"language") == "en-US") {
output += "\n        ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"storesForPersonalShopper");
if(t_3) {var t_1;
if(runtime.isArray(t_3)) {
var t_2 = t_3.length;
for(t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1][0]
frame.set("region", t_3[t_1][0]);
var t_5 = t_3[t_1][1]
frame.set("stores", t_3[t_1][1]);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n            ";
if(t_4 && runtime.memberLookup((runtime.memberLookup((t_5),0)),"country") == runtime.contextOrFrameLookup(context, frame, "USRegionCode")) {
output += "\n                <optgroup label=\"";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "\">\n                    ";
env.getTemplate("./select-store-options.j2", false, "help/templates/personal-stylist/select-store-us.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n                </optgroup>\n            ";
})});
}
output += "\n        ";
;
}
} else {
t_1 = -1;
var t_2 = runtime.keys(t_3).length;
for(var t_10 in t_3) {
t_1++;
var t_11 = t_3[t_10];
frame.set("region", t_10);
frame.set("stores", t_11);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n            ";
if(t_10 && runtime.memberLookup((runtime.memberLookup((t_11),0)),"country") == runtime.contextOrFrameLookup(context, frame, "USRegionCode")) {
output += "\n                <optgroup label=\"";
output += runtime.suppressValue(t_10, env.opts.autoescape);
output += "\">\n                    ";
env.getTemplate("./select-store-options.j2", false, "help/templates/personal-stylist/select-store-us.j2", null, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
output += t_13
output += "\n                </optgroup>\n            ";
})});
}
output += "\n        ";
;
}
}
}
frame = frame.pop();
output += "\n        ";
frame = frame.push();
var t_18 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"storesForPersonalShopper");
if(t_18) {var t_16;
if(runtime.isArray(t_18)) {
var t_17 = t_18.length;
for(t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16][0]
frame.set("region", t_18[t_16][0]);
var t_20 = t_18[t_16][1]
frame.set("stores", t_18[t_16][1]);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
output += "\n            ";
if(t_19 && runtime.memberLookup((runtime.memberLookup((t_20),0)),"country") == runtime.contextOrFrameLookup(context, frame, "CARegionCode")) {
output += "\n                <optgroup label=\"";
output += runtime.suppressValue(t_19, env.opts.autoescape);
output += "\">\n                    ";
env.getTemplate("./select-store-options.j2", false, "help/templates/personal-stylist/select-store-us.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n                </optgroup>\n            ";
})});
}
output += "\n        ";
;
}
} else {
t_16 = -1;
var t_17 = runtime.keys(t_18).length;
for(var t_25 in t_18) {
t_16++;
var t_26 = t_18[t_25];
frame.set("region", t_25);
frame.set("stores", t_26);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
output += "\n            ";
if(t_25 && runtime.memberLookup((runtime.memberLookup((t_26),0)),"country") == runtime.contextOrFrameLookup(context, frame, "CARegionCode")) {
output += "\n                <optgroup label=\"";
output += runtime.suppressValue(t_25, env.opts.autoescape);
output += "\">\n                    ";
env.getTemplate("./select-store-options.j2", false, "help/templates/personal-stylist/select-store-us.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
output += "\n                </optgroup>\n            ";
})});
}
output += "\n        ";
;
}
}
}
frame = frame.pop();
output += "\n    ";
;
}
else {
output += "\n        ";
frame = frame.push();
var t_33 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"storesForPersonalShopper");
if(t_33) {var t_31;
if(runtime.isArray(t_33)) {
var t_32 = t_33.length;
for(t_31=0; t_31 < t_33.length; t_31++) {
var t_34 = t_33[t_31][0]
frame.set("region", t_33[t_31][0]);
var t_35 = t_33[t_31][1]
frame.set("stores", t_33[t_31][1]);
frame.set("loop.index", t_31 + 1);
frame.set("loop.index0", t_31);
frame.set("loop.revindex", t_32 - t_31);
frame.set("loop.revindex0", t_32 - t_31 - 1);
frame.set("loop.first", t_31 === 0);
frame.set("loop.last", t_31 === t_32 - 1);
frame.set("loop.length", t_32);
output += "\n            ";
if(t_34 && runtime.memberLookup((runtime.memberLookup((t_35),0)),"country") == runtime.contextOrFrameLookup(context, frame, "CARegionCode")) {
output += "\n                <optgroup label=\"";
output += runtime.suppressValue(t_34, env.opts.autoescape);
output += "\">\n                    ";
env.getTemplate("./select-store-options.j2", false, "help/templates/personal-stylist/select-store-us.j2", null, function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
t_36.render(context.getVariables(), frame, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
output += t_37
output += "\n                </optgroup>\n            ";
})});
}
output += "\n        ";
;
}
} else {
t_31 = -1;
var t_32 = runtime.keys(t_33).length;
for(var t_40 in t_33) {
t_31++;
var t_41 = t_33[t_40];
frame.set("region", t_40);
frame.set("stores", t_41);
frame.set("loop.index", t_31 + 1);
frame.set("loop.index0", t_31);
frame.set("loop.revindex", t_32 - t_31);
frame.set("loop.revindex0", t_32 - t_31 - 1);
frame.set("loop.first", t_31 === 0);
frame.set("loop.last", t_31 === t_32 - 1);
frame.set("loop.length", t_32);
output += "\n            ";
if(t_40 && runtime.memberLookup((runtime.memberLookup((t_41),0)),"country") == runtime.contextOrFrameLookup(context, frame, "CARegionCode")) {
output += "\n                <optgroup label=\"";
output += runtime.suppressValue(t_40, env.opts.autoescape);
output += "\">\n                    ";
env.getTemplate("./select-store-options.j2", false, "help/templates/personal-stylist/select-store-us.j2", null, function(t_44,t_42) {
if(t_44) { cb(t_44); return; }
t_42.render(context.getVariables(), frame, function(t_45,t_43) {
if(t_45) { cb(t_45); return; }
output += t_43
output += "\n                </optgroup>\n            ";
})});
}
output += "\n        ";
;
}
}
}
frame = frame.pop();
output += "\n        ";
frame = frame.push();
var t_48 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"storesForPersonalShopper");
if(t_48) {var t_46;
if(runtime.isArray(t_48)) {
var t_47 = t_48.length;
for(t_46=0; t_46 < t_48.length; t_46++) {
var t_49 = t_48[t_46][0]
frame.set("region", t_48[t_46][0]);
var t_50 = t_48[t_46][1]
frame.set("stores", t_48[t_46][1]);
frame.set("loop.index", t_46 + 1);
frame.set("loop.index0", t_46);
frame.set("loop.revindex", t_47 - t_46);
frame.set("loop.revindex0", t_47 - t_46 - 1);
frame.set("loop.first", t_46 === 0);
frame.set("loop.last", t_46 === t_47 - 1);
frame.set("loop.length", t_47);
output += "\n            ";
if(t_49 && runtime.memberLookup((runtime.memberLookup((t_50),0)),"country") == runtime.contextOrFrameLookup(context, frame, "USRegionCode")) {
output += "\n                <optgroup label=\"";
output += runtime.suppressValue(t_49, env.opts.autoescape);
output += "\">\n                    ";
env.getTemplate("./select-store-options.j2", false, "help/templates/personal-stylist/select-store-us.j2", null, function(t_53,t_51) {
if(t_53) { cb(t_53); return; }
t_51.render(context.getVariables(), frame, function(t_54,t_52) {
if(t_54) { cb(t_54); return; }
output += t_52
output += "\n                </optgroup>\n            ";
})});
}
output += "\n        ";
;
}
} else {
t_46 = -1;
var t_47 = runtime.keys(t_48).length;
for(var t_55 in t_48) {
t_46++;
var t_56 = t_48[t_55];
frame.set("region", t_55);
frame.set("stores", t_56);
frame.set("loop.index", t_46 + 1);
frame.set("loop.index0", t_46);
frame.set("loop.revindex", t_47 - t_46);
frame.set("loop.revindex0", t_47 - t_46 - 1);
frame.set("loop.first", t_46 === 0);
frame.set("loop.last", t_46 === t_47 - 1);
frame.set("loop.length", t_47);
output += "\n            ";
if(t_55 && runtime.memberLookup((runtime.memberLookup((t_56),0)),"country") == runtime.contextOrFrameLookup(context, frame, "USRegionCode")) {
output += "\n                <optgroup label=\"";
output += runtime.suppressValue(t_55, env.opts.autoescape);
output += "\">\n                    ";
env.getTemplate("./select-store-options.j2", false, "help/templates/personal-stylist/select-store-us.j2", null, function(t_59,t_57) {
if(t_59) { cb(t_59); return; }
t_57.render(context.getVariables(), frame, function(t_60,t_58) {
if(t_60) { cb(t_60); return; }
output += t_58
output += "\n                </optgroup>\n            ";
})});
}
output += "\n        ";
;
}
}
}
frame = frame.pop();
output += "\n    ";
;
}
output += "\n    ";
frame = frame.push();
var t_63 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"storesForPersonalShopper");
if(t_63) {var t_61;
if(runtime.isArray(t_63)) {
var t_62 = t_63.length;
for(t_61=0; t_61 < t_63.length; t_61++) {
var t_64 = t_63[t_61][0]
frame.set("region", t_63[t_61][0]);
var t_65 = t_63[t_61][1]
frame.set("stores", t_63[t_61][1]);
frame.set("loop.index", t_61 + 1);
frame.set("loop.index0", t_61);
frame.set("loop.revindex", t_62 - t_61);
frame.set("loop.revindex0", t_62 - t_61 - 1);
frame.set("loop.first", t_61 === 0);
frame.set("loop.last", t_61 === t_62 - 1);
frame.set("loop.length", t_62);
output += "\n        ";
if(t_64 && t_64 == runtime.contextOrFrameLookup(context, frame, "UKRegionCode")) {
output += "\n            <optgroup label=\"";
output += runtime.suppressValue(t_64, env.opts.autoescape);
output += "\">\n                ";
env.getTemplate("./select-store-options.j2", false, "help/templates/personal-stylist/select-store-us.j2", null, function(t_68,t_66) {
if(t_68) { cb(t_68); return; }
t_66.render(context.getVariables(), frame, function(t_69,t_67) {
if(t_69) { cb(t_69); return; }
output += t_67
output += "\n            </optgroup>\n        ";
})});
}
output += "\n    ";
;
}
} else {
t_61 = -1;
var t_62 = runtime.keys(t_63).length;
for(var t_70 in t_63) {
t_61++;
var t_71 = t_63[t_70];
frame.set("region", t_70);
frame.set("stores", t_71);
frame.set("loop.index", t_61 + 1);
frame.set("loop.index0", t_61);
frame.set("loop.revindex", t_62 - t_61);
frame.set("loop.revindex0", t_62 - t_61 - 1);
frame.set("loop.first", t_61 === 0);
frame.set("loop.last", t_61 === t_62 - 1);
frame.set("loop.length", t_62);
output += "\n        ";
if(t_70 && t_70 == runtime.contextOrFrameLookup(context, frame, "UKRegionCode")) {
output += "\n            <optgroup label=\"";
output += runtime.suppressValue(t_70, env.opts.autoescape);
output += "\">\n                ";
env.getTemplate("./select-store-options.j2", false, "help/templates/personal-stylist/select-store-us.j2", null, function(t_74,t_72) {
if(t_74) { cb(t_74); return; }
t_72.render(context.getVariables(), frame, function(t_75,t_73) {
if(t_75) { cb(t_75); return; }
output += t_73
output += "\n            </optgroup>\n        ";
})});
}
output += "\n    ";
;
}
}
}
frame = frame.pop();
output += "\n</select>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/personal-stylist/select-store-us.j2"] , dependencies)